import { render, staticRenderFns } from "./addObligee.vue?vue&type=template&id=133f43cc&scoped=true&"
import script from "./addObligee.vue?vue&type=script&lang=js&"
export * from "./addObligee.vue?vue&type=script&lang=js&"
import style0 from "./addObligee.vue?vue&type=style&index=0&lang=less&"
import style1 from "./addObligee.vue?vue&type=style&index=1&id=133f43cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f43cc",
  null
  
)

export default component.exports